import {CompanyReportScreen} from "./ProductsReports.jsx";
export default function ContactReports(){return <CompanyReportScreen kind="contacts"/>;}
